module.exports = __webpack_public_path__ + "img/Barbarian.efa7adfb.png";